/**
 * BLOM Unified Checkout API (Mode A: capture-context + accept-payment).
 */
import ApisMethods from './apisMethods'

export type BlomCaptureContextPayload = {
  purpose: 'service_fee' | 'subscription' | 'template'
  process?: 'upgrade' | 'renew'
  plan_type?: string
  plan_id?: number
  service_fee_id?: number | null
  template_id?: number
  currency_code?: string
}

export type BlomCaptureContextData = {
  capture_context_jwt: string
  client_library_url: string
  external_id: number
  amount?: string
  currency?: string
  reference?: string
}

const BlomApi = {
  createCaptureContext: (
    payload: BlomCaptureContextPayload,
    callback: (res: any) => void,
    setIsLoading?: (v: boolean) => void
  ) => {
    ApisMethods().post(`/vendor/blom/capture-context`, payload, callback, setIsLoading)
  },

  acceptPayment: (
    externalId: number,
    transientTokenJwt: string,
    callback: (res: any) => void,
    setIsLoading?: (v: boolean) => void
  ) => {
    ApisMethods().post(
      `/vendor/blom/accept-payment`,
      {
        external_id: externalId,
        transient_token_jwt: transientTokenJwt,
      },
      callback,
      setIsLoading
    )
  },
}

export default BlomApi
